import React from 'react'
import logo from '../../images/logo.png'

const Contacts = () => {
    return (
      <div className="w-screen h-screen flex items-center flex-col gap-5 lg:text-lg text-sm font-bold">
        <img src={logo} alt="" className="w-20" />
        <div className="">الخرطوم - الطائف - شارع عبيد خاتم - تقاطع الشرقي</div>
        <div className="flex flex-row-reverse gap-2">
          <div className="">:البريد الالكتروني</div>
          <a href="mailto:info@mahsool.sd">info@mahsool.sd</a>
        </div>
        <a href="tel:+971 123 000 111" className="">
          +971 123 000 111 (Dubai)
        </a>
        <div className="">فاكس: 00249-183-472719</div>
        <div className="">ص.ب: 44799 الخرطوم</div>
      </div>
    );
}

export default Contacts